import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type ProfileAction =
  | ActionType<typeof actions.putProfileRequest>
  | ActionType<typeof actions.putProfileSuccess>
  | ActionType<typeof actions.putProfileFail>
  | ActionType<typeof actions.getProfileRequest>
  | ActionType<typeof actions.getProfileSuccess>
  | ActionType<typeof actions.getProfileFail>

export interface ProfileState {
  profile: ProfilePayloadType // | object
}

export enum ProfileActionTypes {
  PUT_PROFILE_REQUEST = '@@profile/PUT_PROFILE_REQUEST',
  PUT_PROFILE_SUCCESS = '@@profile/PUT_PROFILE_SUCCESS',
  PUT_PROFILE_FAIL = '@@profile/PUT_PROFILE_FAIL',
  GET_PROFILE_REQUEST = '@@profile/GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS = '@@profile/GET_PROFILE_SUCCESS',
  GET_PROFILE_FAIL = '@@profile/GET_PROFILE_FAIL'
}

export interface ProfileType {
  profile: ProfilePayloadType
}

export interface ProfilePayloadType {
  firstName: string
  lastName: string
  dob: string
  createdAt?: string // 2019-12-06T13:42:46.003Z,
  deleted?: boolean
  email: string
  id: number
  modifiedAt?: string
  // mobileNumber?: string

  city?: string
  deletedAt?: string // 2019-12-06T13:42:46.003Z
  gender?: any // Ambiguous
  middleInitial?: string
  mobileNumber?: string
  state?: string
  street?: string
  zipCode?: string
}
